


















































































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';

import { fetchDevoluciones } from './fetchDevoluciones';
import { LoadingService } from '@/services/loadingService';
import { Funcionalidades } from '@/config/funcionalidades';
import Confirmation from '@/components/Confirmation.vue';
import DatePicker from '@/reusable/Form/DatePicker.vue';
import moment from 'moment';

@Component({
  components: {
    DatePicker,
    'modal-confirmacion': Confirmation,
  },
})
export default class ComponenteForm extends Vue {
  @Prop({ default: () => ({}) }) data: any;

  @Prop({ default: [] }) listaTipoEquipos: any;
  @Prop({ default: [] }) listaCoordinadores: any[];

  @Prop({ default: false }) creacion: Boolean;
  @Prop({ default: false }) edicion: Boolean;
  @Prop({ default: false }) visualizacion: Boolean;

  mounted() {
    if (this.edicion || this.visualizacion) {
      this.traerInformacion(this.data[0].serienumero, this.data[0].tipoeqid);

      this.equipoSerieNumero = this.data[0].serienumero
        ? this.data[0].serienumero
        : '(Sin Datos)';
      this.requerimiento = this.data[0].devorequerimiento
        ? this.data[0].devorequerimiento
        : '(Sin Datos)';
      this.fechaRecepcion = this.data[0].devofecha_recepcion
        ? moment(this.data[0].devofecha_recepcion)
        : moment();
      this.estado = this.data[0].devoanuladesc;
      //this.data[0].devoanuladesc == 'ANULADO' ? (this.estado = null) : (this.estado = 1);
      if (this.estado == 'ANULADO' || this.estado == 'FINALIZADO')
        this.devAnulada = true;
      this.equipoPorId(this.data[0].tipoeqid);
      this.coordinadorPorId(this.data[0].coorid);
    }
  }

  findFilterList({ key }: { key: string }) {
    return this.listaCoordinadores.filter(x => x[key] !== 't');
  }

  finalizarDevolucion() {
    this.loadingService.showLoading();
    return fetchDevoluciones('finalizarDevolucion', {
      usuarioRut: this.usuarioRut,
      usuarioId: this.usuarioID,
      devonumero: this.data[0].devonumero,
      moduloId: Funcionalidades.Devoluciones,
    })
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.$snotify.success(data.data.MENSAJE_RESPUESTA, 3000);
          this.estado = 'FINALIZADO';
          this.devAnulada = true;
        } else {
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          this.estado = 'VIGENTE';
        }
      })
      .catch((err: any) => this.$snotify.error(err, 3000))
      .finally(() => {
        this.loadingService.hideLoading();
      });
  }

  destroyed() {
    this.reestablecerDatos();
  }

  usuarioNombre = JSON.parse(localStorage.getItem('user')).nombre;
  usuarioApellido = JSON.parse(localStorage.getItem('user')).apellidoPaterno
    ? JSON.parse(localStorage.getItem('user')).apellidoPaterno
    : '';
  usuarioID = JSON.parse(localStorage.getItem('user')).id;
  usuarioRut = JSON.parse(localStorage.getItem('user')).rutClienteDefecto;
  loadingService = new LoadingService();
  $snotify: any;
  usuario = this.usuarioNombre + ' ' + this.usuarioApellido;
  fecha = moment();
  mostrarConf = false;
  devAnulada = false;

  devolucion = '';
  arrComboTipoEquipos: any = [];
  equipoSerieNumero: any = '';
  equipoSeleccionado: any;
  coordinador: any;
  fechaRecepcion = moment();
  fechaBajaSerie: any;
  requerimiento = '';
  SIMSerieNumero = '';
  equipo = '';
  equipoID = 0;
  estado: any = 'VIGENTE';
  estadoSim = '';
  plataforma = '';
  registrada = false;
  numeroActivacion = '';

  emitirParaGuardar() {
    if (this.creacion) {
      let obj = {
        step: 1,
        fechaAlta: this.fecha,
        equipoSerieNumero: this.equipoSerieNumero ? this.equipoSerieNumero : '',
        fechaRecepcion: this.fechaRecepcion ? moment(this.fechaRecepcion) : '',
        fechaBaja: this.fechaBajaSerie ? moment(this.fechaBajaSerie) : '',
        requerimiento: this.requerimiento ? this.requerimiento : '',
        coordinadorID: this.coordinador ? this.coordinador.coorid : '',
        equipoID: this.equipoID,
        userID: this.usuarioID,
        userRUT: this.usuarioRut,
        serieActivaNRO: this.numeroActivacion,
      };
      this.$emit('objCreacion', obj);
    }
    if (this.edicion) {
      let d = this.data[0];
      let obj = {
        devonumero: d.devonumero,
        serienumero: this.equipoSerieNumero
          ? this.equipoSerieNumero
          : d.serienumero,
        idCoordinador: this.coordinador
          ? this.coordinador.coorid
          : d.idCoordinador,
        idEquipo: this.equipoID ? this.equipoID : d.tipoeqid,
        devorequerimiento: this.requerimiento
          ? this.requerimiento
          : d.devorequerimiento,
        usuarioId: this.usuarioID,
        usuarioRut: this.usuarioRut,
        fecharecepcion: this.fechaRecepcion,
      };
      this.$emit('objEdit', obj);
    }
  }

  getComboTipoEquipos() {
    this.loadingService.showLoading(undefined, 'getComboTipoEquipos');
    this.equipoSeleccionado = '';
    return fetchDevoluciones('comboTipoEquipos', {
      equipoSerieNumero: this.equipoSerieNumero,
    })
      .then((data: any) => {
        if (data.data.CODIGO_RESPUESTA == '1') {
          this.arrComboTipoEquipos = data.data.data;
          this.requerimiento = '';
          this.coordinador = '';
        } else {
          this.arrComboTipoEquipos = [];
          this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
        }
      })
      .catch((err: any) => console.error(err))
      .finally(() => this.loadingService.hideLoading('getComboTipoEquipos'));
  }

  traerInformacion(serieNum: any, Equipoid: any) {
    if (this.edicion || this.visualizacion) {
      this.loadingService.showLoading(undefined, 'traerInformacion');
      let body = {
        equipoSerieNumero: serieNum,
        equipoID: Equipoid,
        accion: this.edicion ? 'editar' : 'visualizar',
      };
      return fetchDevoluciones('infoDevolucion', body)
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            let info = data.data.data[0];

            this.estadoSim = info.configvalor
              ? info.configvalor
              : '(Sin Datos)';

            this.SIMSerieNumero = info.simserienumero
              ? info.simserienumero
              : '(Sin Datos)';

            this.registrada =
              info.serieactivaplata_ingresada == 'S' ? true : false;

            this.plataforma = info.descplataforma
              ? info.descplataforma
              : '(Sin Datos)';

            this.numeroActivacion = info.serieactivanro
              ? info.serieactivanro
              : '(Sin Datos)';

            this.equipoPorId(this.equipoSeleccionado.tipoeqid);

            this.fechaBajaSerie = info.serieactivafecha_baja
              ? moment(info.serieactivafecha_baja)
              : null;
          } else {
            this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
            this.reestablecerDatos();
          }
        })
        .catch((err: any) => console.error(err))
        .finally(() => this.loadingService.hideLoading('traerInformacion'));
    } else {
      this.emitirParaGuardar();
      if (this.equipoSeleccionado.tipoeqname) {
        let body = {
          equipoSerieNumero: this.equipoSerieNumero,
          equipoID: this.equipoSeleccionado
            ? this.equipoSeleccionado.tipoeqid
            : '',
          numeroActivacion: this.equipoSeleccionado.serieactivanro,
          accion: 'crear',
        };
        return fetchDevoluciones('infoDevolucion', body)
          .then((data: any) => {
            if (data.data.CODIGO_RESPUESTA == '1') {
              let info = data.data.data[0];

              this.equipoPorId(this.equipoSeleccionado.tipoeqid);

              this.numeroActivacion = info.serieactivanro
                ? info.serieactivanro
                : '(Sin Datos)';

              this.plataforma = info.descplataforma
                ? info.descplataforma
                : '(Sin Datos)';

              this.registrada =
                info.serieactivaplata_ingresada == 'S' ? true : false;

              this.SIMSerieNumero = info.simserienumero
                ? info.simserienumero
                : '(Sin Datos)';

              this.estadoSim = info.configvalor
                ? info.configvalor
                : '(Sin Datos)';

              this.fechaBajaSerie = info.serieactivafecha_baja
                ? moment(info.serieactivafecha_baja)
                : null;

              this.emitirParaGuardar();
            } else {
              this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
              this.reestablecerDatos();
            }
          })
          .catch((err: any) => console.error(err))
          .finally(() => this.loadingService.hideLoading('traerInformacion'));
      } else {
        this.$snotify.warning(
          'Por favor, complete los campos obligatorios',
          3000
        );
        this.loadingService.hideLoading('traerInformacion');
      }
    }
  }

  async anularDevo(respuesta: any) {
    if (respuesta && this.estado == 'ANULADO') {
      this.loadingService.showLoading(undefined, 'anularDevo');
      return fetchDevoluciones('anularDevolucion', {
        devonumero: this.data[0].devonumero,
        userID: this.usuarioID,
        userRUT: this.usuarioRut,
        moduloID: Funcionalidades.Devoluciones,
      })
        .then((data: any) => {
          if (data.data.CODIGO_RESPUESTA == '1') {
            this.$snotify.success(data.data.MENSAJE_RESPUESTA, 3000);
            this.devAnulada = true;
          } else {
            this.$snotify.error(data.data.MENSAJE_RESPUESTA, 3000);
          }
        })
        .catch((err: any) => console.error(err))
        .finally(() => this.loadingService.hideLoading('anularDevo'));
    } else this.estado = 'VIGENTE';
    this.mostrarConf = false;
  }

  equipoPorId(id: any) {
    this.listaTipoEquipos.forEach((e: any) => {
      if (e.tipoeqid == id) {
        this.equipoSeleccionado = e.tipoeqname;
        this.equipoID = e.tipoeqid;
      }
    });
  }

  coordinadorPorId(id: any) {
    this.listaCoordinadores.forEach((c: any) => {
      if (c.coorid == id) {
        this.coordinador = c;
      }
    });
  }

  get fechaMaxima() {
    const hoy = new Date();
    let fechaMax =
      hoy.getFullYear() +
      '-' +
      this.dosCifras((hoy.getMonth() + 1).toString()) +
      '-' +
      this.dosCifras(hoy.getDate().toString());
    return fechaMax;
  }

  dosCifras(valor: string) {
    return valor.length == 1 ? '0' + valor : valor;
  }

  reestablecerDatos() {
    this.devolucion = '';
    this.equipoSerieNumero = '';
    this.coordinador = '';
    this.fechaRecepcion = moment();
    this.requerimiento = '';
    this.SIMSerieNumero = '';
    this.equipo = '';
    this.equipoID = 0;
    this.estado = null;
    this.estadoSim = '';
    this.plataforma = '';
    this.registrada = false;
    this.fechaBajaSerie = null;
    this.numeroActivacion = '';
    this.equipoSeleccionado = '';
    this.arrComboTipoEquipos = [];
    this.$emit('ocultarGuardar');
  }
}
